import { saveSessionData } from '@lms/api-client/backend';

/**
 * Persist SCORM runtime data for a session. Ports `saveSession` from the Next
 * app's features/scormplayer/actions.ts. The Next version called
 * `revalidatePath` on the trainee dashboard after a status change; in the SPA
 * the dashboard revalidates itself on window focus (see useAutoRefresh), so we
 * only need the backend write here.
 */
export async function saveSession(
  sessionId: string,
  _personalCode: string,
  sessionData: Record<string, unknown>,
): Promise<void> {
  await saveSessionData(sessionId, sessionData);
}
